import { FunctionComponent as F, useState } from "react";
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import { Box, Stack, Typography } from "@mui/material";
import NewFolderDialog from "./NewFolderDialog";

interface IProps
{
  drawerOpen: boolean
}

const AddFolder: F<IProps> = (props: IProps) =>
{
  const [newFolderDialog, setNewFolderDialog] = useState(false);

  return (
    <Box sx={{ mt: '15px', mb: '15px', cursor: 'pointer' }}>

      <Stack
        direction='row'
        onClick={() => setNewFolderDialog(true)}
        width={'220px'}
        sx={{ alignItems: 'center' }}>
        <CreateNewFolderIcon sx={{ mr: '15px' }} color={'success'}/>
        {props.drawerOpen ? <Typography variant='body2' noWrap>{"Add folder"}</Typography> : <></>}
      </Stack>

      <NewFolderDialog
        open={newFolderDialog}
        close={() => setNewFolderDialog(false)}/>

    </Box>);
}

export default AddFolder;